import * as React from 'react';
import { FareFeaturePaymentType } from '@websky/graphql';
import { OverridedIcons } from '@websky/core';

export const paymentIcons = {
	[FareFeaturePaymentType.Pay]: (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path
				d="M12.5479 13.7783H6V12.3984H12.5479C13.1865 12.3984 13.7109 12.2959 14.1211 12.0908C14.5312 11.8857 14.833 11.5957 15.0264 11.2207C15.2256 10.8457 15.3252 10.4033 15.3252 9.89355C15.3252 9.47754 15.2314 9.0791 15.0439 8.69824C14.8623 8.31738 14.5664 8.00391 14.1562 7.75781C13.752 7.51172 13.2158 7.38867 12.5479 7.38867H9.50684V18.7969H7.81934V6H12.5479C13.5146 6 14.3291 6.16699 14.9912 6.50098C15.6533 6.8291 16.1543 7.28613 16.4941 7.87207C16.8398 8.45215 17.0127 9.12012 17.0127 9.87598C17.0127 10.6963 16.8398 11.3994 16.4941 11.9854C16.1543 12.5654 15.6533 13.0107 14.9912 13.3213C14.3291 13.626 13.5146 13.7783 12.5479 13.7783ZM12.4424 14.9824V16.3711H6V14.9824H12.4424Z"
				fill="currentColor"
			/>
		</svg>
	)
};

export const icons: OverridedIcons = {
	Choosed: () => (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				id="Subtract"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM17.7071 9.70711C18.0976 9.31658 18.0976 8.68342 17.7071 8.29289C17.3166 7.90237 16.6834 7.90237 16.2929 8.29289L10.6842 13.9016L7.70711 10.9245C7.31658 10.5339 6.68342 10.5339 6.29289 10.9245C5.90237 11.315 5.90237 11.9482 6.29289 12.3387L10.6842 16.73L17.7071 9.70711Z"
				fill="white"
			/>
		</svg>
	)
};
